RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.VersionErrorModal = Marionette.ItemView.extend({
        template: '#shellVersionErrorModal',
        className: 'modal',

        events: {
            'click .x-reload-btn': 'reloadPage'
        },

        reloadPage: function () {
            window.location.reload();
        },

        onBeforeShow: function () {
            $('body').addClass('blur-content');
        },

        onShow: function () {
            const me = this;
            me.$el.modal({
                backdrop: 'static'
            });
        }
    });
});
